import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import YouTubeSvg from '@img/youtube-logo.svg';
import * as React from 'react';
import ReactPlayer from 'react-player';
import S from './VideoModal.styles';
const VideoModal = ({ isVisible = false, closeBtnTxt, url, youtubeUrl, isImage, onClick, }) => {
    if (!url) {
        return null;
    }
    return (React.createElement(S.Container, { "data-visible": isVisible },
        React.createElement(S.CloseBtn, { branding: "white", styleType: "outline", title: closeBtnTxt, addon: getSvgFromSystem(SystemIcon.Close), addonPosition: "left", onClick: () => onClick() }),
        React.createElement(S.VideoHolder, null,
            React.createElement(S.VideoContainer, { isImage: isImage },
                React.createElement(S.VideoWrapper, null, isImage ? (React.createElement(React.Fragment, null,
                    React.createElement(S.Image, { src: url }))) : (React.createElement(ReactPlayer, { url: url, playing: isVisible, controls: true, playsinline: true, width: "100%", height: "100%" }))),
                youtubeUrl && (React.createElement(S.YouTubeLink, { href: youtubeUrl, target: "_blank" },
                    "Watch more on: ",
                    React.createElement(YouTubeSvg, null)))))));
};
export default VideoModal;
